module.exports = __webpack_public_path__ + "img/liu-teacher-wechat-qr.496c4f13.png";